export default __webpack_public_path__ + "static/media/Terms_Conditions.4148971a.pdf";